import React from 'react';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { CheckCircle } from '@insurancemenu/imenu-components-lib/dist/icons';
import StepHeader from 'components/common/headers/StepHeader';
import { observer } from 'mobx-react-lite';
import ICensusUploadPageStore, { CensusUploadDomainParams } from 'store/modules/census/iCensusUploadPageStore';
import { ICensusModule } from 'store/modules/census/iCensusModule';
import { ValidCensusSectionStyled } from './styles';
import { StepSubtitleStyled } from '../StepSubtitleStyled';
import { COMPLETE_CENSUS_BTN_TEST_ID, VALID_CENSUS_SECTION_TEST_ID } from '../constants';

interface Props {
  pageStore: ICensusUploadPageStore<CensusUploadDomainParams, ICensusModule<CensusUploadDomainParams>>;
}

const ExistingValidCensusSection: React.FC<Props> = observer(({ pageStore: { censusModule, onCompleteRedirect } }) => {
  const { existingCensusInfo, noUploadedFiles } = censusModule;

  return (
    <ValidCensusSectionStyled $disabled={!censusModule.noUploadedFiles} data-test-id={VALID_CENSUS_SECTION_TEST_ID}>
      <StepHeader
        stepIcon={<CheckCircle width="3.2rem" color={noUploadedFiles ? colors.green[600] : colors.neutral[300]} />}
        stepTitle="Census Ready"
        stepSubtitle={
          <StepSubtitleStyled>{`Your Census with ${existingCensusInfo?.familyAmount} subscribers has been successfully validated and has no errors. You still need to submit it in order to register employee elections.`}</StepSubtitleStyled>
        }
      />
      <Button
        onClick={onCompleteRedirect}
        size="large"
        color="custom"
        customColor={colors.green[600]}
        disabled={!noUploadedFiles}
        data-test-id={COMPLETE_CENSUS_BTN_TEST_ID}
      >
        Continue
      </Button>
    </ValidCensusSectionStyled>
  );
});

export default ExistingValidCensusSection;
